import TYPES from '@/types';

// Application
import OnboardingSearchStepsQuery
  from '@/modules/onboarding/status/application/queries/onboarding-search-steps-query';

// Domain
import Inject from '@/modules/shared/domain/di/inject';
import { MessageNotifier } from '@/modules/shared/domain/notifiers/message_notifier';

export default class OnboardingViewModel {
  @Inject(TYPES.ONBOARDING_SEARCH_STEPS_QUERY)
  private readonly get_all_boarding_steps_query!: OnboardingSearchStepsQuery;

  @Inject(TYPES.NOTIFIER)
  private readonly message_notifier!: MessageNotifier;

  show_stopper_modal_to_client = false;

  initialize = async () => {
    await this.unserializeToken();
  }

  unserializeToken = async () => {
    const token = sessionStorage.getItem('authorization');
    if (token) {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const json = JSON.parse(window.atob(base64));
      if (json && (json
        .is_logged_in_by_customer === undefined || json.is_logged_in_by_customer === true)) {
        await this.verifyIfUserCanContinue();
      }
    }
  }

  verifyIfUserCanContinue = async () => {
    try {
      const steps = await this.get_all_boarding_steps_query.execute();
      const new_client_was_added = steps.find((step) => step.current_step === 'new_client_was_added');
      if (new_client_was_added) {
        const identity_verification = steps.find((step) => step.current_step === 'identity_verification');
        if (identity_verification && identity_verification.payload.status === 'verified') {
          this.show_stopper_modal_to_client = true;
        }
      }
    } catch {
      this.message_notifier.showErrorNotification('Ocurrió un error al obtener su progreso actual, favor de recargar la página');
    }
  }
}
